var _desc, _defs, _mask;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "26px",
    viewBox: "0 0 20 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pin-start") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 20 0 20 26 0 26"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pin-start"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m10.002 0c-5.5111 0-10.002 4.5378-10.002 10.111 0 4.0617 2.4223 7.8664 4.7586 10.702 2.3364 2.8352 4.6727 4.7254 4.6727 4.7254l0.57035 0.46211 0.57035-0.46211s2.3364-1.8902 4.6727-4.7254c2.3364-2.8352 4.7552-6.6399 4.7552-10.702 0-5.5732-4.4872-10.111-9.9983-10.111",
    fill: "#7ED321",
    style: {
      fill: "#d8232a"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m7.3349 8.6106c-0.00405 2.596-1.7476 3.9872-4.132 3.4314-0.86771-0.2025-1.5339-0.69862-1.8994-1.5248-0.48701-1.0986-0.5103-2.2316-0.069863-3.3433 0.50726-1.2798 1.782-1.9349 3.3088-1.7628 1.461 0.16504 2.4381 1.0297 2.6932 2.3986 0.0567 0.31388 0.078975 0.63382 0.099226 0.80089zm-1.385 0.22174c-0.12352-0.49815-0.030456-0.93859-0.19246-1.3385-0.29666-0.73406-0.89707-1.0803-1.6777-1.0672-0.76545 0.01316-1.3244 0.38779-1.5987 1.1077-0.34526 0.90619-0.35539 1.8245 0.11644 2.6902 0.648 1.1897 2.3743 1.2221 3.0345 0.0405 0.24705-0.44044 0.17423-0.97504 0.31801-1.4327z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.7913 6.4975v1.7223h1.7061c0.18529 0 0.39892-0.05569 0.54878 0.01822 0.1944 0.09518 0.33716 0.29362 0.5022 0.44752-0.15795 0.16099-0.30172 0.44044-0.47689 0.4617-0.54878 0.0648-1.1087 0.0324-1.6646 0.03645-0.18428 9.9e-4 -0.36855 0-0.59029 0-0.01721 0.15694-0.04151 0.28451-0.04252 0.41209-5e-3 0.57308 4e-3 1.1451-0.0061 1.7182-0.0091 0.5508-0.2511 0.84442-0.6642 0.8343-0.39589-0.01013-0.62674-0.2916-0.62876-0.81506-0.00607-1.6676-0.00705-3.3352 0-5.0017 0.00308-0.60345 0.2187-0.81506 0.83126-0.82114 1.0105-0.01013 2.0209-0.0051 3.0314 0 0.34324 2e-3 0.67534 0.07391 0.66319 0.50828-0.01215 0.4293-0.34222 0.48195-0.68749 0.48094-0.82114-4e-3 -1.6433-2e-3 -2.5221-2e-3z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.331 6.4955v1.7233h1.619c0.18529 0 0.37159 9.9e-4 0.55688 9.9e-4 0.324 0.0011 0.57814 0.10125 0.57814 0.4779 0 0.38272-0.27742 0.47182-0.58522 0.47992-0.45562 0.01317-0.91125 5e-3 -1.3669 0.0061h-0.7938c-0.01215 0.20554-0.02835 0.36855-0.02936 0.53055-4e-3 0.55688 0.0081 1.1138-0.0061 1.6706-0.01013 0.41108-0.16504 0.7533-0.63484 0.75735-0.46372 4e-3 -0.64901-0.31185-0.65002-0.73609-5e-3 -1.7212-0.01013-3.4415 4e-3 -5.1627 4e-3 -0.52549 0.21971-0.72394 0.76039-0.73102 1.0459-0.01417 2.0918-0.0071 3.1377-1e-3 0.33109 2e-3 0.62775 0.10226 0.61864 0.50321-0.0091 0.3969-0.2997 0.48195-0.63686 0.48094-0.83835-1e-3 -1.6777 0-2.5718 0z",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinOff);
export default __webpack_public_path__ + "static/media/pin-off.b4353b733d02f7587b07f1fb81202b2a.svg";
export { ForwardRef as ReactComponent };